<template>
  <b-tabs content-class="mt-4" class="block__tabsCommercials">
    <b-tab v-for="(list,index) in lists" :key="index" :title="list.title">
      <b-list-group>
        <b-list-group-item v-for="(subList,index) in list.ranking" :key="index">

          <b-button class="bt-list" :to="parent + '/' + subList.link">
            <div class="left">
            <PuSkeleton circle :loading="isLoading" :count="1" width='20px' height="20px">
              <div class="icon" :class="putTheRightClass(subList.icon)">
                {{subList.icon}}
              </div>
            </PuSkeleton>
              <div class="list-number">
                <PuSkeleton :loading="isLoading" :count="1" width='20px' height="20px">
                  {{index + 1 }}
                </PuSkeleton>
              </div>
              <div class="fullname">
                <PuSkeleton :loading="isLoading" :count="1" width='120px'>
                  {{subList.fullname}}
                </PuSkeleton>
              </div>
            </div>

            <div class="right">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1" width='40px'>
                  {{subList.result}}
                </PuSkeleton>
              </div> 
              <div class="target" :class="putTheRightClass(subList.target)">
                <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                  {{subList.target}}
                </PuSkeleton>
              </div>
              <div class="chevron">
                  <i class="far fa-chevron-right"></i>
              </div>              
            </div>
          </b-button>

        </b-list-group-item>
      </b-list-group>
    </b-tab>
  </b-tabs>
</template>

<script>
import Utils from "../../Utils"
import { mapGetters } from 'vuex'
//
export default {
  name: "TabsCommercials",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getGeneral',
      ])
    },  
  props:{
    lists:{
      type:Object
    },
    parent:{
      type:String,
      default:'Parent',
    },    
  },
  data(){
    return { 
      content:"",
      isPositif:false,
      isLoading:true,
    }
  },  
  methods : {
    putTheRightClass (target){
      return Utils.getTheClass(target);
    },
  },  
  mounted (){
  },
  created(){
    this.content = this.getGeneral;
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }    
}
</script>